// import './modules/_toggle-state';
import './modules/particles';
import './modules/slider-promote-job';
import './modules/slider-picto-text';
import './modules/_toggle-state';
import './modules/primary-header';
import './modules/animation-homepage';
import './modules/_select-corner';
import './modules/modal-video';

/*
	BEWARE
	when you update the scripts, you need to copy the bundle generated in convert it in babel compiler (https://babeljs.io/repl).
	Than move the transpiled version to application/assets/legacy.js
	the lagacy file is loaded in layout-footer.twig
	This fix is required as far as we support IE11
*/
